import React from "react";
import Button from '@mui/material/Button';
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import useAddLabRequestHook from "./addLabEnteryHook";
import { allowNumbersOnly } from "../../../utils/helper";
import { DataGrid } from '@mui/x-data-grid';
import "./addLabEntery.scss";
import { labEntryColumns } from "./addLabEnteryColumn";
import LabHeaderInfo from "./labHeader";

const initialState = []
const AddLabEntery = () => {
    const { handleChange, handleSubmit, handleGoBack, handleBlur,
        setlabEntry,
        labEntry,
        errors: { errors },
        labEntryBillState } = useAddLabRequestHook(initialState);

    const headerObj = {
        headerOneLabel: labEntryBillState && labEntryBillState[0]?.billNumber,
        headerTwoLabel: labEntryBillState && labEntryBillState[0]?.billTime,
        headerThreeLabel: labEntryBillState && labEntryBillState[0]?.departmentName,
        headerFourLabel: labEntryBillState && labEntryBillState[0]?.totalAmount
    }

    const actionColumn = [
        {
            field: "observedValue",
            headerName: "Observed value",
            width: 250,
            renderCell: (params) => {
                return (
                    <form className="needs-validation" novalidate>
                        <div className="cellWithImg">
                                    <input onBlur={handleBlur}
                                        className={"form-control"}
                                        id="observedValue"
                                        required
                                        placeholder="Oberved Value" name="observedValue"
                                        value={labEntry && labEntry[params?.id]?.observedValue}
                                        onChange={(e) => handleChange(e, params, "observedValue")}
                                        onKeyDown={(e) => allowNumbersOnly(e)} />
                        </div>
                    </form>
                );
            },
        },
    ];
    const remarksColumn = [
        {
            field: "remarks",
            headerName: "Remarks",
            width: 250,
            renderCell: (params) => {
                return (
                    <form className="needs-validation" novalidate>
                        <div className="cellWithImg">
                                    <input
                                        className={"form-control"}
                                        id="remarks"
                                        required
                                        placeholder="Remarks" name="remarks"
                                        value={labEntry && labEntry[params?.id]?.remarks}
                                        onChange={(e) => handleChange(e, params, "remarks")}
                                    />
                        </div>
                    </form>
                );
            },
        },
    ];

    return (
        <>

            <div className="add-lab" >
                <div className="mt-2 ml-4">
                    <h4>Add Lab Entery Information</h4>
                    <div className="back-btn"
                    >
                        <ArrowBackIcon className="arrow-color"

                        />
                        <span
                            onClick={handleGoBack}
                            style={{ cursor: "pointer" }}
                            className="anchr-link header-text mt-3 mb-3"
                        >
                            {"Back"}
                        </span>
                    </div>
                </div>
            </div>
            {labEntryBillState?.length > 0 ? <LabHeaderInfo
                data={headerObj} /> : null}
            <div className="lab-table mt-5 p-3">
                <div className="d-flex justify-content-end mr-0 mb-3">
                    <Button variant="outlined" className="mr-2"
                        onClick={(event) => {
                            handleSubmit(event)
                            setlabEntry({})
                        }
                        }
                    >
                        Add Lab Entery</Button>
                </div>
                <DataGrid
                    className="datagrid"
                    autoHeight
                    rows={labEntryBillState?.length > 0 ? labEntryBillState : []}
                    columns={[...labEntryColumns, ...actionColumn, ...remarksColumn]}
                    pageSize={10}
                    rowsPerPageOptions={[5]}
                    disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                    getRowId={(row) => row.componentID}
                    checkboxSelection={false}

                />

            </div>
        </>
    )
}

export default AddLabEntery;

